import React from 'react';
import { connect } from 'react-redux';
import { setSearchState } from 'store/actions';
import {
  Paper,
  InputBase,
  IconButton
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  container: {
    marginRight: 16,
    display: 'flex'
  },
  icon: {
    padding: 2,
    margin: 2
  },
  input: {
    paddingLeft: '.5em',
    flexGrow: 1
  }
});

const Search = ({ classes, setSearchState, searchBoxValue }) => {

  const onSearchClick = () => {
    setSearchState({ searchIsOpen: true });
  }

  const onSearchChange = e => {
    setSearchState({ searchBoxValue: e.target.value, searchIsOpen: true });
  }

  return (
    <Paper className={classes.container}>
      <InputBase
        className={classes.input}
        placeholder="Search"
        inputProps={{ 'aria-label': 'search in app' }}
        onClick={onSearchClick}
        onChange={onSearchChange}
        value={searchBoxValue}
        readOnly
      />
      <IconButton className={classes.icon} size='small' aria-label="search" onClick={onSearchClick}>
        <SearchIcon />
      </IconButton>
    </Paper>
  );
};

const mapState = state => ({
  searchBoxValue: state.searchState.searchBoxValue,
});
const mapDispatch = dispatch => ({
  setSearchState: state => dispatch(setSearchState(state)),
});
export default compose(
  withStyles(styles),
  connect(mapState, mapDispatch)
)(Search);
